// Import model
import { StartEstimateAddFreightRequest } from '../models/StartEstimateAddFreightRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateAddFreightRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateAddFreightRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateAddFreightRequest instance
   */
  static deserialize(json: string): StartEstimateAddFreightRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateAddFreightRequest instance
   */
  static fromObject(obj: any): StartEstimateAddFreightRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateAddFreightRequest');
    }


    const instance: StartEstimateAddFreightRequest = {
      itemId: obj['itemId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateAddFreightRequest instances
   */
  static deserializeArray(json: string): StartEstimateAddFreightRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateAddFreightRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateAddFreightRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateAddFreightRequest instance to a plain object
   */
  static toObject(instance: StartEstimateAddFreightRequest): any {
    return {
      'itemId': instance.itemId,
    };
  }

  /**
   * Serializes an array of StartEstimateAddFreightRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateAddFreightRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
